import {Injectable} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ForecastService extends ProjectConstants {

  header: any;
  baseUrl: string = servers.apiUrl + urls.serviceChanges;

  constructor(private http: HttpClient) {
    super();
  }

  save(url: string, object: any) {
    const body = object ? JSON.stringify(object) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post(url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}
